/**
 * Placeholder for blog images. Keyed by a unique string (e.g. image URL) so the
 * same picture gets the same placeholder. No network, no processing.
 */

const GRAY_PLACEHOLDER_SVG =
  '<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40"><defs><linearGradient id="g" x1="0%" y1="0%" x2="100%" y2="100%"><stop offset="0%" style="stop-color:#e5e7eb"/><stop offset="100%" style="stop-color:#9ca3af"/></linearGradient></defs><rect width="40" height="40" fill="url(#g)"/></svg>';

const FALLBACK_DATA_URL =
  "data:image/svg+xml," + encodeURIComponent(GRAY_PLACEHOLDER_SVG);

/** Simple string hash for deterministic placeholder colors. */
function hashKey(key: string): number {
  let h = 0;
  for (let i = 0; i < key.length; i++) {
    h = (h << 5) - h + key.charCodeAt(i);
    h |= 0;
  }
  return Math.abs(h);
}

/** Muted colors (not bright) for placeholders: grays, soft blues, sage, beige, dust, etc. */
const MUTED_PALETTE = [
  "#e5e7eb",
  "#d1d5db",
  "#9ca3af",
  "#b8c5d0",
  "#a8b8b8",
  "#c4c8d4",
  "#b5b9a8",
  "#c9c2b8",
  "#a8b4c4",
  "#b8b4c0",
  "#b0b8a8",
  "#c0b8b4",
  "#9ba8b0",
  "#a8b0a8",
  "#b4a8b4",
  "#a0a8b8",
];

function svgForHash(h: number): string {
  const i1 = h % MUTED_PALETTE.length;
  const i2 = (h * 7 + 1) % MUTED_PALETTE.length;
  const c1 = MUTED_PALETTE[i1];
  const c2 = MUTED_PALETTE[i2];
  return `<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40"><defs><linearGradient id="g" x1="0%" y1="0%" x2="100%" y2="100%"><stop offset="0%" style="stop-color:${c1}"/><stop offset="100%" style="stop-color:${c2}"/></linearGradient></defs><rect width="40" height="40" fill="url(#g)"/></svg>`;
}

/**
 * Returns a deterministic placeholder data URL for the given key (e.g. image URL).
 * Same key → same placeholder. Empty key → fallback gray.
 */
export function getBlogPlaceholderForKey(key: string | undefined): string {
  if (!key || !key.trim()) return FALLBACK_DATA_URL;
  const h = hashKey(key);
  const svg = svgForHash(h);
  return "data:image/svg+xml," + encodeURIComponent(svg);
}

/** Composable: returns a placeholder for the given key, or fallback when no key. */
export function useBlogPlaceholder(key?: string): string {
  return key ? getBlogPlaceholderForKey(key) : FALLBACK_DATA_URL;
}
